import { render, staticRenderFns } from "./EduExerciseCategory.vue?vue&type=template&id=140b5a86&scoped=true"
import script from "./EduExerciseCategory.vue?vue&type=script&lang=js"
export * from "./EduExerciseCategory.vue?vue&type=script&lang=js"
import style0 from "./EduExerciseCategory.vue?vue&type=style&index=0&id=140b5a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140b5a86",
  null
  
)

export default component.exports